export class PhoneNumber {
  constructor(
    readonly number: string,
    readonly formattedNumber: string,
  ) {}
}
